import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const mainCategories = categories.slice(0, 3);

const cardStyles = [
  {
    bg: 'bg-stone-900',
    textColor: 'text-white',
    subColor: 'text-stone-400',
    badgeBg: 'bg-white/15',
    badgeText: 'text-white',
  },
  {
    bg: 'bg-rose-100',
    textColor: 'text-stone-800',
    subColor: 'text-stone-500',
    badgeBg: 'bg-stone-900/70',
    badgeText: 'text-white',
  },
  {
    bg: 'bg-stone-50',
    textColor: 'text-stone-800',
    subColor: 'text-stone-500',
    badgeBg: 'bg-amber-100',
    badgeText: 'text-amber-800',
  },
];

export default function CategorySection() {
  return (
    <section className="relative bg-stone-100/70 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <p className="text-[10px] font-medium text-stone-400 uppercase tracking-[0.2em] mb-3">
              分类浏览
            </p>
            <h2 className="text-3xl md:text-4xl font-[family-name:var(--font-heading)] text-stone-800 leading-snug">
              探索你的下一部<br />心动漫画
            </h2>
          </div>
          <Link
            to="/category/langman-aiqing"
            className="text-sm text-stone-500 hover:text-stone-800 transition-colors inline-flex items-center gap-1 whitespace-nowrap"
          >
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mainCategories.map((cat, idx) => {
            const style = cardStyles[idx];
            return (
              <Link
                key={cat.slug}
                to="/category/all"
                className={`group relative overflow-hidden rounded-2xl p-8 md:p-10 min-h-[280px] flex flex-col justify-between transition-all duration-300 hover:scale-[1.02] cursor-pointer ${style.bg}`}
              >
                <div>
                  <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 ${style.badgeBg}`}>
                    <i className={`${cat.icon} text-xl ${style.badgeText}`}></i>
                  </div>
                  <h3 className={`text-2xl md:text-3xl font-bold font-[family-name:var(--font-heading)] ${style.textColor}`}>
                    {cat.name}
                  </h3>
                </div>
                <div>
                  <p className={`text-sm ${style.subColor}`}>
                    {cat.count}+ 部作品
                  </p>
                  <span className={`inline-flex items-center gap-1.5 mt-2 text-sm font-medium transition-all duration-200 group-hover:gap-2.5 whitespace-nowrap ${style.textColor}`}>
                    立即浏览 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}